// extracted by mini-css-extract-plugin
export default {"RadiusXS":"1px","tableBorder":"G57d11d","table":"G94ada6","tableMargins":"Gcc7bf9","tablePadding":"Gbdbe84","loadingSkeleton":"Gf32e4b","loading-skeleton":"G931f01"};